var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaneHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 28,
    viewBox: "0 0 96 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29_624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7547 2.44006L43.7097 11.9351L43.8747 12.1151L44.0847 12.2351L57.2547 19.3751H41.2497L32.8347 12.7451L29.8947 2.45506H34.7397M35.3997 0.940063H27.9297L31.5447 13.6151L40.7397 20.8751H63.1797L44.8047 10.9151L35.3997 0.940063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7645 20.3201L87.5695 16.2551C85.1245 14.6351 82.2745 13.7801 79.3195 13.7801H47.9695L49.3495 14.6051L51.1045 15.4001H79.3195C81.8995 15.3701 84.4795 16.1501 86.6695 17.5901L89.0695 19.1501H23.6545L26.1895 20.7851H91.5595L92.8795 21.6551C93.8095 22.2701 94.2445 23.4401 93.9145 24.5051C93.5995 25.5701 92.5945 26.3201 91.4845 26.3351H15.5845L1.90453 17.1851V15.4001H35.2045L34.2895 14.6051V13.7801H12.7045L9.71953 1.82508C9.62953 1.46508 9.29953 1.21008 8.92453 1.21008H1.09453C0.869531 1.21008 0.674531 1.30008 0.509531 1.45008C0.359531 1.60008 0.269531 1.81008 0.269531 2.03508V17.6201C0.269531 17.8901 0.404531 18.1451 0.629531 18.2951L14.8795 27.8351C15.0145 27.9251 15.1795 27.9851 15.3295 27.9701H91.4695V27.9851C93.2995 27.9851 94.9495 26.7551 95.4745 25.0001C95.9995 23.2301 95.2945 21.3101 93.7495 20.3051L93.7645 20.3201ZM1.90453 2.81508H8.23453L10.9645 13.7651H1.90453V2.81508Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29_624"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 95.4,
    height: 27.06,
    fill: "white",
    transform: "translate(0.269531 0.940063)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneHome);
export default __webpack_public_path__ + "static/media/plane_home.47baa7bcf32f62df45fb38f110b48150.svg";
export { ForwardRef as ReactComponent };